/*
 * Created By Anup Shrestha
 * Copyright (c) 2021. All rights reserved.
 * Last Modified 12/23/21, 9:01 AM
 *
 *
 */

import * as React from 'react';
import { resolveValue, Toast, Toaster } from 'react-hot-toast';
import { Oval } from 'react-loading-icons';
import { Transition } from '@headlessui/react';
import { CheckCircle, WarningCircle } from 'phosphor-react';

const ToastBase = () => {
  return (
    <Toaster gutter={24}>
      {(t: Toast) => {
        return (
          <Transition as="div" appear show={t.visible}>
            {t.type === 'loading' ? (
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95 -translate-y-32"
                enterTo="opacity-100 scale-100 translate-y-0"
                leave="transition-all duration-150"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-75"
              >
                <div className="flex min-w-[30rem] max-w-3xl rounded-lg bg-white shadow-md">
                  <div className="flex items-center justify-center rounded-l-lg bg-gray-500 px-3 text-5xl text-white shadow-lg">
                    <Oval strokeWidth={5} height="2rem" />
                  </div>

                  <div className="px-4 py-3">
                    <div className="flex flex-col">
                      <span className="font-Inter #dark:text-primary-400 text-2xl font-medium text-gray-700">
                        Loading
                      </span>
                      <p className="font-Inter #dark:text-gray-200 max-w-2xl text-xl  text-gray-500  line-clamp-2 ">
                        {resolveValue(t.message, t)}
                      </p>
                    </div>
                  </div>
                </div>
              </Transition.Child>
            ) : t.type === 'error' ? (
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95 -translate-y-32"
                enterTo="opacity-100 scale-100 translate-y-0"
                leave="transition-all duration-150"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-75"
              >
                <div className="#dark:bg-gray-800 flex min-w-[30rem] max-w-3xl rounded-lg bg-white shadow-md">
                  <div className="flex items-center justify-center rounded-l-lg bg-red-500 px-4 text-white shadow-lg">
                    <WarningCircle weight="fill" size={32} />
                  </div>

                  <div className="px-4 py-3">
                    <div className="flex flex-col">
                      <span className="font-Inter #dark:text-primary-400 text-2xl font-medium text-red-600">
                        Error
                      </span>
                      <p className="font-Inter #dark:text-gray-200 max-w-lg text-xl text-gray-500  line-clamp-2 ">
                        {resolveValue(t.message, t)}
                      </p>
                    </div>
                  </div>
                </div>
              </Transition.Child>
            ) : (
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom=" -translate-y-32"
                enterTo=" translate-y-0"
                leave="transition-all duration-150"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-75"
              >
                <div className="#dark:bg-gray-800 flex min-w-[30rem] max-w-3xl rounded-lg bg-white shadow-md">
                  <div className="flex items-center justify-center rounded-l-lg bg-emerald-500 px-4 text-5xl text-white shadow-lg">
                    <CheckCircle weight="fill" size={32} />
                  </div>

                  <div className="px-4 py-3">
                    <div className="flex flex-col">
                      <span className="font-Inter #dark:text-primary-400 text-2xl font-medium text-emerald-600">
                        Success
                      </span>
                      <p className="font-Inter #dark:text-gray-200 max-w-2xl text-xl text-gray-500  line-clamp-2 ">
                        {resolveValue(t.message, t)}
                      </p>
                    </div>
                  </div>
                </div>
              </Transition.Child>
            )}
          </Transition>
        );
      }}
    </Toaster>
  );
};

export default ToastBase;
